import { useEffect, useRef } from 'react';

/**
 * Attaches the video source only once the element is near the viewport, so
 * the section clips don't compete with the hero video for bandwidth.
 * The element needs `data-src` instead of `src` and no `autoPlay`.
 */
export default function useLazyVideo() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !el.dataset.src) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        el.src = el.dataset.src;
        el.play().catch(() => {});
        observer.disconnect();
      },
      { rootMargin: '300px' }
    );
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return ref;
}
